import React from "react";
import {Redirect} from "react-router";
import api from '../../api/Api';
import {NavLink} from 'react-router-dom';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'
import Loader from '../../components/Loader'
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import Hospital from "@material-ui/icons/LocalHospital";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import ArtTrack from "@material-ui/icons/ArtTrack";
import Launch from "@material-ui/icons/Launch";
import Tooltip from "@material-ui/core/Tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import {dashboardRouter, mappingUI} from '../../util/globalHelper'
import SweetAlert from "react-bootstrap-sweetalert";
import Permissions from '../../util/globalPermissions';

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    }
};

class readOneClinic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            notFound: null,
            open: true,//
            element: "",//
            api_url: "",//
            api_status: "",//
            read: false,
            alert: null,
            clickedId: "",
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            selectedClinicmasterId: "",
            doctor_data: []
        };
        this.CreateAlerts = this.CreateAlerts.bind(this)
        this.Doctor = this.Doctor.bind(this)
    }

    componentDidMount() {
        this.CallReadApi(this.props.match.params.clinicID);
        this.CreateAlerts = this.CreateAlerts.bind(this)


    }

    successDelete() {
        this.setState({
            alert: (
                <SweetAlert
                    success
                    style={{display: "block", marginTop: "-100px"}}
                    title="Deleted!"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                >
                </SweetAlert>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"user_id": id};
        api.deleteDoctor(postBody)
            .then(json => {
                this.CallReadApi(this.props.match.params.clinicID);
                // window.location.reload()
            });

    }

    hideAlert() {
        this.setState({
            alert: null
        });

    }

    CreateAlerts(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure?"
                    onConfirm={() => {
                        this.successDelete();
                        this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will not be able to recover this doctor!
                </SweetAlert>
            )
        });
    }

    Doctor(stations) {
        const {classes} = this.props;
        const globalThis = this;
        return <GridContainer>
            {this.state.alert}
            {
                stations && this.state.data ? stations.map(function (station, i) {
                    return <GridItem xs={12} sm={6} md={4} style={{display: 'grid'}} key={i}>
                        {[
                            <Card key={Math.random()} product className={classes.cardHover}
                                  style={{minHeight: 400, textAlign: 'center'}}>
                                <CardHeader image className={classes.cardHeaderHover} style={{textAlign: 'center'}}>
                                    <a href="#pablo" onClick={e => e.preventDefault()}>
                                        <img src={station.user_id ? station.user_id.profile_image : ''}
                                             onError={(e) => {
                                                 e.onerror = null;
                                                 e.target.src = require('assets/img/placeholder.jpg')
                                             }}
                                             style={{maxWidth: '70%'}} alt=""/>
                                    </a>
                                </CardHeader>
                                <CardBody style={{textAlign: 'center'}}>
                                    <div className={classes.cardHoverUnder}>
                                        <NavLink to={dashboardRouter(`/doctor/oneDoctor/${station._id}`)}>
                                            <Tooltip
                                                id="tooltip-top"
                                                title="View"
                                                placement="bottom"
                                                classes={{tooltip: classes.tooltip}}
                                            >
                                                <Button color="transparent" simple justIcon>
                                                    <ArtTrack/>
                                                </Button>
                                            </Tooltip></NavLink>
                                        <NavLink to={dashboardRouter(`/doctor/updateDoctorDetails/${station._id}`)}>
                                            <Tooltip
                                                id="tooltip-top" title="Edit" placement="bottom"
                                                classes={{tooltip: classes.tooltip}}
                                            >
                                                <Button color="success"
                                                        simple justIcon>
                                                    <Edit/>
                                                </Button>
                                            </Tooltip></NavLink>
                                        <Tooltip
                                            id="tooltip-top"
                                            title="Remove"
                                            placement="bottom" classes={{tooltip: classes.tooltip}}
                                        >
                                            <Button color="danger" simple justIcon
                                                    onClick={() =>
                                                        globalThis.CreateAlerts(station.user_id._id)
                                                    }>
                                                <Delete/>
                                            </Button>
                                        </Tooltip>
                                    </div>
                                    <GridItem>
                                        <h4 className={classes.cardProductTitle}>
                                            <a href="#pablo" onClick={e => e.preventDefault()}>
                                            </a>
                                        </h4>
                                        <TagsInput tagProps={{className: "react-tagsinput-tag info"}}
                                                   disabled
                                                   value={station.speciality.map(function (obj) {
                                                       return obj.speciality;
                                                   })}
                                                   inputProps={{placeholder: ""}}/>
                                        <p className={classes.cardProductDesciprion} style={{color: 'black'}}>
                                            {station.display_name}
                                        </p>
                                    </GridItem>
                                    <GridItem>
                                        <p className={classes.cardProductDesciprion} style={{color: 'black'}}>
                                            <b>Contact: </b>{station.user_id.contact}
                                        </p>
                                        <p className={classes.cardProductDesciprion} style={{color: 'black'}}>
                                            <b>Email:</b> {station.user_id.email !== "" ? station.user_id.email : "N/A"}
                                        </p>
                                        <p className={classes.cardProductDesciprion} style={{color: 'black'}}>
                                            <b>Qualification:</b> {station.qualification !== "" ? station.qualification : "N/A"}
                                        </p>
                                        <p className={classes.cardProductDesciprion} style={{color: 'black'}}>
                                            <b>Experience:</b> {station.experience !== "" ? station.experience + " years of experience" : "N/A"}
                                        </p>
                                    </GridItem>
                                </CardBody>

                            </Card>
                        ]}
                    </GridItem>;
                }) : null
            }
        </GridContainer>
    }


    render() {
        const {classes} = this.props;
        const {data} = this.state;
        if (this.state.data) {
            return (<div className="leftAlight">
                    {this.state.alert}
                    <Card className="text-center">
                        <CardHeader style={{paddingBottom: 0}}>
                            <GridItem className="leftAlight">
                                <h2>{data.clinic_name}</h2>
                                <TagsInput size="lg" tagProps={{className: "react-tagsinput-tag info"}}
                                           value={data.clinic_categories.map(function (obj) {
                                               return obj.category;
                                           })} disabled
                                           onChange={this.handleChange} inputProps={{placeholder: ""}}/>
                            </GridItem>
                        </CardHeader>
                        <CardBody className="leftAlight">

                            <GridContainer className="leftAlight">

                                <GridItem xs={12}>
                                    <GridItem>
                                        <h4>{data.clinic_description ? data.clinic_description[0] === "<" ?
                                            <div
                                                dangerouslySetInnerHTML={{__html: data.clinic_description}}/> : data.clinic_description : null}
                                        </h4>
                                    </GridItem>
                                </GridItem>

                                <GridItem md={4} sm={6} xs={12}>

                                    <GridItem xs={12}>
                                        <h4>
                                            <b>{data.clinic_address.addressline !== "" ? data.clinic_address.addressline + ", " : ""}{data.clinic_address.locality !== "" ? data.clinic_address.locality + ", " : ""}<br></br>
                                                {data.clinic_address.city !== "" ? data.clinic_address.city + ", " : "Address Not Available"}{data.clinic_address.state !== "" ? data.clinic_address.state : ""}
                                            </b></h4>
                                        <h5>Address {data.google_map_link && data.google_map_link !== "" ? (<a
                                            href={`https://${data.google_map_link}`}
                                            target="_blank">(View on map)</a>) : null}</h5>
                                    </GridItem>
                                    <GridItem xs={12}>
                                        <h4><b>{data.clinic_contact}</b></h4>
                                        <h5>Contact</h5>
                                        {data.secondary_numbers ? data.secondary_numbers.map(item => {
                                            return <div><h4><b>{item.number}</b></h4>
                                                <h5>{item.label}</h5></div>
                                        }) : null}
                                    </GridItem>

                                    <GridItem xs={12} md={12}>
                                        <h4><b>
                                            {data.unique_url !== "" ?
                                                <a href={data.unique_url !== "http://" ? `https://myhealthspace.in/clinic/${data.unique_url}` : null}
                                                   target='_blank'>{data.unique_url}
                                                    <Launch style={{padding: '5 0 0 5'}}/>
                                                </a> : null}
                                        </b></h4>
                                        <h5>URL</h5>
                                    </GridItem>
                                </GridItem>

                                <GridItem md={4} sm={6} xs={12}>

                                    <GridItem xs={12} md={12}>
                                        <h4>
                                            {data.clinic_website !== "" ? (
                                                <a href={data.clinic_website !== "http://" ? `https://${data.clinic_website}` : null}
                                                   target='_blank'>
                                                    <b>{data.clinic_website}</b>
                                                    <Launch style={{padding: '5 0 0 5'}}/>
                                                </a>) : (
                                                <b>Not Available</b>)}
                                        </h4>
                                        <h5>Website</h5>
                                    </GridItem>
                                    <GridItem xs={12} md={12}>
                                        <h4><b>{data.clinic_email !== "" ? data.clinic_email : "Not Available"}</b>
                                        </h4>
                                        <h5>Email</h5>
                                    </GridItem>

                                </GridItem>

                                <GridItem md={3}>
                                    <img
                                        data-src="holder.js/100px180/"
                                        alt="Clinic Image"
                                        style={{display: "block", maxWidth: '100%', height: 'auto'}}
                                        src={data.clinic_images ? data.clinic_images[0] : ''}
                                        data-holder-rendered="true"
                                        onError={(e) => {
                                            e.onerror = null;
                                            e.target.src = require('assets/img/image_placeholder.jpg')
                                        }}
                                    />
                                    <br/>
                                    {mappingUI(Permissions.UpdateClinic) ?
                                        <NavLink to={dashboardRouter(`/clinic/updateClinic/${data.clinic_id}`)}>
                                            <Button block color="warning">
                                                <Icon>border_color</Icon>
                                                <span style={{paddingLeft: 10}}>Update</span>
                                            </Button></NavLink> : null}


                                </GridItem>
                                <GridItem xs={12}>
                                    <GridItem>
                                        <hr/>
                                    </GridItem>
                                </GridItem>
                                <GridItem md={4} sm={6} xs={12}>

                                    <GridItem xs={12}>
                                        <h3><b>Timings:</b></h3>
                                        <h5>
                                            <b>Monday</b>: {data.clinic_timings[0].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[0].open_time !== "" ? data.clinic_timings[0].open_time + "-" + data.clinic_timings[0].close_time : "Closed"}
                                        </h5>
                                        <h5>
                                            <b>Tuesday</b>: {data.clinic_timings[1].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[1].open_time !== "" ? data.clinic_timings[1].open_time + "-" + data.clinic_timings[1].close_time : "Closed"}
                                        </h5>
                                        <h5>
                                            <b>Wednesday</b>{data.clinic_timings[2].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[2].open_time !== "" ? data.clinic_timings[2].open_time + "-" + data.clinic_timings[2].close_time : "Closed"}
                                        </h5>
                                        <h5>
                                            <b>Thursday</b>: {data.clinic_timings[3].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[3].open_time !== "" ? data.clinic_timings[3].open_time + "-" + data.clinic_timings[3].close_time : "Closed"}
                                        </h5>
                                        <h5>
                                            <b>Friday</b>: {data.clinic_timings[4].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[4].open_time !== "" ? data.clinic_timings[4].open_time + "-" + data.clinic_timings[4].close_time : "Closed"}
                                        </h5>
                                        <h5>
                                            <b>Saturday</b>:{data.clinic_timings[5].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[5].open_time !== "" ? data.clinic_timings[5].open_time + "-" + data.clinic_timings[5].close_time : "Closed"}
                                        </h5>
                                        <h5>
                                            <b>Sunday</b>: {data.clinic_timings[6].open_24 ? "12:00 AM - 12:00 AM" : data.clinic_timings[6].open_time !== "" ? data.clinic_timings[6].open_time + "-" + data.clinic_timings[6].close_time : "Closed"}
                                        </h5>
                                    </GridItem>

                                </GridItem>
                                <GridItem md={4} sm={6} xs={12}>

                                    <GridItem xs={12} md={12}>
                                        <h3><b>Services:</b></h3>
                                        {
                                            data.clinic_services.map(function (object) {
                                                return <h5 key={Math.random()}> {object.service} </h5>;
                                            })}

                                    </GridItem>

                                </GridItem>

                            </GridContainer>
                            <GridItem xs={12}>
                                <hr/>
                            </GridItem>
                            <GridItem xs={12} md={3}>
                                <h3><b>List of Doctors</b></h3>
                            </GridItem>

                            {this.state.data.clinic_doctors.length > 0 ? (
                                //List of clinics
                                <GridItem>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} md={2}>
                                            <NavLink
                                                to={dashboardRouter(`/doctor/addDoctor/${data.clinic_master_id._id}/${data.clinic_id}`)}>
                                                <Button block color="warning">
                                                    <Icon>add</Icon>
                                                    <span style={{paddingLeft: 10}}>ADD NEW</span>
                                                </Button></NavLink>
                                        </GridItem>
                                    </GridContainer>
                                    <br></br><br></br><br></br><br></br>
                                    <GridContainer>
                                        <GridItem xs={12}>
                                            {this.Doctor(data.clinic_doctors)}
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>) : (
                                //Empty Clinic View

                                <Card>
                                    <GridItem>
                                        <GridContainer style={{justifyContent: 'center', textAlign: 'center'}}>
                                            <GridItem xs={12} style={{justifyContent: 'center'}}>
                                                <br/><br/>
                                                <Hospital style={{fontSize: 75}}/>

                                            </GridItem>
                                            <GridItem xs={12} style={{justifyContent: 'center'}}>
                                                <h3>No Doctors Found</h3>
                                            </GridItem>
                                            <GridItem xs={12} style={{justifyContent: 'center'}}>
                                                <h4>Looks like you have no doctors yet.<br/> Click on the button below
                                                    to add a doctor. <br/><br/>.
                                                </h4>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={2} style={{justifyContent: 'center'}}>
                                                <NavLink
                                                    to={dashboardRouter(`/doctor/addDoctor/${data.clinic_master_id._id}/${data.clinic_id}`)}>
                                                    <Button block size="lg" color="success">
                                                        <Icon>add</Icon>

                                                        <span style={{paddingLeft: 10}}>ADD</span>
                                                    </Button></NavLink>
                                                <br/><br/>
                                            </GridItem>
                                        </GridContainer>
                                        <br/><br/><br/>
                                    </GridItem>
                                </Card>)}
                        </CardBody>
                    </Card>
                </div>
            );
        } else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        } else
            return (<div>
                <Loader/>
            </div>)
    }


    CallReadApi(id) {
        api.getClinicById(id).then(({data}) => {
            this.setState({data: data.data})
        }).catch(error => {
            this.setState({notFound: error})
        });
    }
}

export default withStyles(dashboardStyle)(readOneClinic);



// WEBPACK FOOTER //
// ./src/views/Clinics/oneClinic.jsx